import { createFileRoute } from '@tanstack/react-router';
import { EmailLogPage } from '@/features/admin/emailLog/EmailLogPage';

/**
 * Registro delle e-mail (super-admin): ogni e-mail in uscita con l'esito — spedita, non partita, solo registrata,
 * invio spento. Si apre da «Posta in uscita» in `/admin/system`. Contratto `BE-TO-FE-EMAIL-LOG-v1`.
 */
export const Route = createFileRoute('/_app/admin/email-log')({ component: EmailLogPage });
